import { render, staticRenderFns } from "./bf-guide.vue?vue&type=template&id=bf831100&"
import script from "./bf-guide.vue?vue&type=script&lang=js&"
export * from "./bf-guide.vue?vue&type=script&lang=js&"
import style0 from "./bf-guide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Chevron: require('/usr/src/app/components/account/common-elements/icons/chevron.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default})
